export const DISPENSE_CASH = 'DISPENSE_CASH';
export const SET_CASSETES = 'SET_CASSETES';